if (!window['CF_PAGE_BUILDER']) {
	document.addEventListener('DOMContentLoaded', initFAQ)
}

function initFAQ() {
	var items = document.querySelectorAll('.com-sec-content-1__items:not(.is-initialized)');

	[].forEach.call(items, function (elements) {
		var item = elements.querySelectorAll('.com-sec-content-1__item');

		[].forEach.call(item, function (el) {
			var button = el.querySelector('.com-sec-content-1__item-button');

			button.addEventListener('click', function () {
				var selection = document.getSelection();
				var expanded = button.getAttribute('aria-expanded') === 'true' || false;

				if (selection && selection.toString()) {
					return;
				}

				el.classList.toggle('is-active');

				button.setAttribute('aria-expanded', !expanded);
			});

			el.addEventListener('focusin', function (e) {
				if (button === e.target) {
					el.classList.add('is-focused');
				}
			});

			el.addEventListener('focusout', function () {
				el.classList.remove('is-focused');
			});
		});

		elements.classList.add('is-initialized');
	});
}
